import { assertSupabaseConfigured, supabase } from "../lib/supabase";
import type { TeamMember } from "../types/trainer";

export const teamService = {
  async listMembers(tenantId: string): Promise<TeamMember[]> {
    assertSupabaseConfigured();

    const { data, error } = await supabase
      .from("tenant_memberships")
      .select("*, tenants(*), profiles(id,email,full_name,status)")
      .eq("tenant_id", tenantId)
      .order("created_at", { ascending: true });

    if (error) throw error;
    return (data ?? []) as TeamMember[];
  },
};
